import {isModelId,type CodexNotification,type ThreadRecord} from '@reados/contracts';
/** Only an accepted context for this exact Quick Chat can replace its model. */
export function acceptedQuickChatModel(threadId:string,events:CodexNotification[]):string|undefined {
 for(const event of [...events].reverse()){
  if(event.method!=='reados/quickChatContext')continue;
  const snapshot=event.params.snapshot;
  if(snapshot&&typeof snapshot==='object'&&'version' in snapshot&&(snapshot.version===1||snapshot.version===2)&&'threadId' in snapshot&&snapshot.threadId===threadId&&'model' in snapshot&&isModelId(snapshot.model))return snapshot.model;
 }
 return undefined;
}
export const quickChatModel=(value:unknown)=>isModelId(value)?value:'';

/** Current server-authored ancestry, never the last accepted Quick model. */
export function quickChatSourceModel(threadId:string,threads:readonly ThreadRecord[]):string|undefined {
 const seen=new Set<string>();let current=threads.find(thread=>thread.id===threadId);
 if(!current?.quickChat)return undefined;
 while(current?.quickChat){
  if(seen.has(current.id))return undefined;seen.add(current.id);
  const parentId:string|undefined=current.quickChat.parentThreadId;if(!parentId)return undefined;
  current=threads.find(thread=>thread.id===parentId);
 }
 return current?.modelSelection??current?.model;
}
